// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-m_hc","advertDetailService__price":"c-m_he"};